








































import mixins from 'vue-typed-mixins';
import { WorksheetResult, Worksheet } from '@/utils/WorksheetUtils';
import SurveyUtils, {
  QuestionParticipation,
  Survey,
  SurveyParticipation,
  Question,
} from '@/utils/SurveyUtils';
import { ReportContext, ReportNode, QuestionData } from '@/utils/ReportUtils';
import SurveyNodeUtils from '@/utils/SurveyNodeUtils';
import SubOrganizationUtils, {
  SubOrganization,
} from '@/utils/SubOrganizationUtils';
import QuestionVue from '@/components/survey/report/nodes/Question.vue';
import PointsOfServiceUtils, {
  PointsOfService,
} from '@/utils/PointsOfServiceUtils';

export default mixins().extend({
  components: {
    QuestionVue,
  },

  props: {
    value: {
      type: Object as () => WorksheetResult,
    },

    worksheet: {
      type: Object as () => Worksheet,
      required: true,
    },
  },

  computed: {
    suborganizationselect(): any {
      return {
        label:
          this.$translate(
            this.value?.participation?.survey?.languageobjects?.suborg
          ) || this.$tc('model.survey.suborg'),
        items: this.context.suborganizations?.map((suborganization) => ({
          text: this.$translate(suborganization.name),
          value: suborganization,
        })),
        visible: this.context.nodes?.some(
          (node) =>
            this.value?.answers?.find(
              (answer) => answer?.answer?.questionid === node.item.id
            )?.answer?.displaytype === 'suborg'
        ),
      };
    },

    questions(): {
      node: ReportNode<Question, QuestionData>;
      suborganization?: SubOrganization;
    }[] {
      return (
        this.context.nodes?.map((node: any) => ({
          node: node,
          // if the worksheet result was suborg, pass the selected suborg down to the question
          suborganization:
            this.value?.answers?.find(
              (answer) => answer?.answer?.questionid === node.item.id
            )?.answer?.displaytype === 'suborg'
              ? this.suborganization
              : undefined,
        })) || []
      );
    },

    valid(): boolean {
      return this.questions?.every((item) => item?.node.data.valid);
    },
  },

  data(): {
    context: ReportContext;
    suborganization?: SubOrganization;
  } {
    return {
      context: {
        path: [],
        nodes: undefined,
        survey: undefined,
        surveyParticipation: undefined,
        documents: {
          items: undefined,
          options: {
            showAllDocuments: false,
          },
        },
        suborganizations: undefined,
        pointsofservices: undefined,
        mode: ['worksheet'],
      },
      suborganization: undefined,
    };
  },

  watch: {
    value() {
      this.load();
    },
  },

  methods: {
    async load() {
      try {
        const current = this.value?.participation?.id;

        if (this.value?.participation?.id) {
          this.$alert.hide('load');

          this.context.survey = this.value?.participation?.survey as Survey;
          this.context.surveyParticipation = this.value
            ?.participation as SurveyParticipation;

          this.suborganization = undefined;
          this.context.suborganizations = undefined;
          this.context.nodes = undefined;

          const resp = await Promise.all([
            SubOrganizationUtils.api.list({
              surveyparticipationid: this.value.participation.id,
            }),
            PointsOfServiceUtils.api.list({
              surveyparticipationid: this.value.participation.id,
            }),
            Promise.all(
              this.value.answers
                ?.filter((answer) => answer?.answer?.questionid)
                .map(async (answer) => {
                  return SurveyNodeUtils.generateNode(
                    await SurveyUtils.api.question.get(
                      answer?.answer?.questionid
                    )
                  ) as ReportNode<Question, QuestionData>;
                })
            ),
          ]);

          if (current === this.value?.participation?.id) {
            this.context.suborganizations = resp[0];
            this.suborganization =
              this.context.suborganizations?.length > 0
                ? this.context.suborganizations[0]
                : undefined;

            this.context.pointsofservices = resp[1];

            this.context.nodes = resp[2];
          }
        }
      } catch (error) {
        this.$alert.show('load', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },

    cancel() {
      this.$emit('input');
    },

    async submit() {
      try {
        this.$alert.hide('submit');

        await Promise.all(
          (this.$refs.questions as any)
            .filter((questions: any) => typeof questions.save === 'function')
            .map((questions: any) => questions.save())
        );

        this.$emit('input');
        this.$emit('submit');

        this.$toast.push({
          type: 'success',
          text: this.$languageobj('validation.success.default', {
            values: [this.$languageobj('model.question.label')],
          }),
        });
      } catch (error) {
        this.$alert.show('submit', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
